'use client'

import Image from "next/image";
import { ReactNode } from "react";
import { getStatusColor } from "../../lib/utils";
import { Defense, Status } from "../../lib/definitions";
import Tooltip from "../../ui/tooltip";
import DateToLocaleString from "../../ui/dateToLocaleString";

import styles from "./page.module.css"

type Props = {
  problemLevel: number
  problemId: number
  problemName: string
  rating: number
  defense: Defense
  status: Status
  date: Date
  elapsedTime: ReactNode
}
const LogTableRow = ({
  problemLevel,
  problemId,
  problemName,
  rating,
  defense,
  status,
  date,
  elapsedTime,
}: Props) => {
  return (
    <div className={styles.tableRow}>
      <div className={styles.tableRowProblemId}>
        <Image src={`https://static.solved.ac/tier_small/${problemLevel}.svg`} width={20} height={20} alt="level" />
        <a
          href={`https://www.acmicpc.net/problem/${problemId}`}
          target="_blank"
        >
          {problemId}
        </a>
      </div>
      <a
        className={styles.tableRowProblemName}
        href={`https://www.acmicpc.net/problem/${problemId}`}
        target="_blank"
      >
        {problemName}
      </a>
      <p className={styles.tableRowRating}>{rating}</p>
      <p className={styles.tableRowDefense}>{defense}</p>
      <p
        className={styles.tableRowStatus}
        style={{
          color: getStatusColor(status),
        }}
      >
        {status}
      </p>
      <Tooltip tooltip={<DateToLocaleString date={date} />}>
        <div className={styles.tableRowElapsedTime}>
          {elapsedTime}
        </div>
      </Tooltip>
    </div>
  )
}

export default LogTableRow